// extracted by mini-css-extract-plugin
export default {"logoutBtn":"Nav_logoutBtn__7XjE8"};